import {Entity} from '@s-ui/domain'

export class GigyaSignatureEntity extends Entity {
  #uid
  #signature
  #timestamp

  static create({uid, signature, timestamp}) {
    return new GigyaSignatureEntity({uid, signature, timestamp})
  }

  static createFromGigyaApiResponse(gigyaResponse) {
    const {UID: uid, UIDSignature: signature, signatureTimestamp: timestamp} = gigyaResponse
    return GigyaSignatureEntity.create({uid, signature, timestamp})
  }

  /**
   * @constructor
   * @param {Object} deps
   * @param {String} deps.uid
   * @param {String} deps.uidSignature
   * @param {Integer} deps.signatureTimestamp
   */
  constructor({uid, signature, timestamp}) {
    super()
    this.#uid = uid
    this.#signature = signature
    this.#timestamp = timestamp
  }

  toJSON() {
    return {
      uid: this.#uid,
      signature: this.#signature,
      timestamp: this.#timestamp
    }
  }
}
